import { render, staticRenderFns } from "./DlgTopic.vue?vue&type=template&id=2a3fecb3&scoped=true&"
import script from "./DlgTopic.vue?vue&type=script&lang=ts&"
export * from "./DlgTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fecb3",
  null
  
)

export default component.exports